export default __webpack_public_path__ + "static/media/time.510db411.svg";